import { Component, forwardRef, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { TreeSelectorComponent } from "@components/tree-selector/tree-selector.component";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { IProduktgruppFilter } from "~app/features/planera/model/IProduktgruppFilter";
import { ArbetsorderSearchBase } from "../../../models/arbetsorder-search-base";

@Component({
    selector: "rask-arbetsorder-search-skoglig-data-produktgrupper",
    templateUrl: "./arbetsorder-search-skoglig-data-produktgrupper.component.html",
    styleUrls: ["./arbetsorder-search-skoglig-data-produktgrupper.component.scss"],
    providers: [
        { provide: ArbetsorderSearchBase,
            useExisting: forwardRef(() => ArbetsorderSearchSkogligDataProduktgrupperComponent) }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TreeSelectorComponent,
        InputNumberComponent,
        FormsModule,
        RadiobuttonGroupComponent
    ]
})
export class ArbetsorderSearchSkogligDataProduktgrupperComponent extends ArbetsorderSearchBase implements OnInit {
    selectedProduktgrupper: IProduktgruppFilterWithName[];
    allProduktgrupper: SelectionItem[];
    boolskaoperationer: IRadiobuttonItem[];

    constructor() {
        super();
        this.boolskaoperationer = [
            { key: "and",
                value: "Arbetsorder skall innehålla alla produktgrupper" },
            { key: "or",
                value: "Arbetsorder skall innehålla en eller flera produktgrupper" }
        ];
    }

    ngOnInit() {
        this.allProduktgrupper = this.basdata.produktgrupper.map(grupp => ({
            text: grupp.namn,
            id: grupp.id
        } as SelectionItem));

        this.applyFilter();
    }

    forceUpdateFilterChange(): void {
        this.applyFilter();
    }

    applyFilter() {
        this.selectedProduktgrupper = this.searchFilter.skogligdata.produktgrupper;

        if (this.selectedProduktgrupper.length > 0) {
            this.selectedProduktgrupper.forEach(grupp => {
                grupp.namn = this.basdata.produktgrupper.find(apg => apg.id === grupp.produktgrupp).namn;
            });
        }
        this.allProduktgrupper.forEach(grupp => {
            grupp.selected = (this.selectedProduktgrupper.find(existing => existing.produktgrupp === grupp.id) !== undefined);
        });
    }

    updateSelectedProduktgruppList() {
        this.allProduktgrupper.forEach(allpg => {
            const foundSelectedIndex = this.selectedProduktgrupper.findIndex(grupp => grupp.produktgrupp === allpg.id);

            if (!allpg.selected) {
                if (foundSelectedIndex > -1) {
                    this.selectedProduktgrupper.splice(foundSelectedIndex, 1);
                }
            }

            if (allpg.selected) {
                if (foundSelectedIndex < 0) {
                    this.selectedProduktgrupper.push({ produktgrupp: allpg.id,
                        namn: allpg.text } as IProduktgruppFilterWithName);
                }
            }
        });
    }

    hasMoreThanOneProduktGrupp() {
        return this.selectedProduktgrupper?.length > 1;
    }
}

interface IProduktgruppFilterWithName extends IProduktgruppFilter {
    namn?: string;
}
